import endpoints from "api/endpoints";
import axiosNeuron from "api/axios";
import moment from "moment";

export async function updateLabelPosition({
  id,
  start,
  end,
  timezoneOffset,
  placements,
  value,
}: {
  id: number;
  start: number;
  end: number;
  timezoneOffset?: number;
  placements?: number[];
  value?: number;
}) {
  const url = endpoints.labels.default;
  const newData = {
    start_datetime: moment.unix(start).format("YYYY-MM-DD HH:mm:ss.SSS"),
    end_datetime: moment.unix(end).format("YYYY-MM-DD HH:mm:ss.SSS"),
    placements,
    value,
  };

  const tz = timezoneOffset ? `?tz=${encodeURIComponent(timezoneOffset)}` : "";

  try {
    const data = await axiosNeuron.patch(`${url}${id}/${tz}`, newData);
    return data;
  } catch (error) {
    if (error !== undefined) {
      throw error;
    }
  }
}
